<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<div class="img_container"><img alt="images" src="images/f0002-01.jpg"/>
<p class="caption"><em class="italic">The author on “Snuffles,” France, 1916</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm01.vue?5b8f0509